import _ from "lodash";

// noinspection NpmUsedModulesInstalled
const process = require('process');

// noinspection JSUnresolvedVariable
const configurations = typeof config === 'undefined'? {} : config;

export const app = {
    name: process.env.APP_NAME || _.get(configurations, 'app.name'),
    description: process.env.APP_DESCRIPTION || _.get(configurations, 'app.description'),
    url: process.env.APP_URL || _.get(configurations, 'app.url'),
};
